import { logger } from '../../../datadog';
import { normalizeError } from '../../../utils';
import { isZoomExecutedFailure } from './error';

/**
 * Handles a Zoom operation that returns ExecutedResult and handles failures
 * @param operation - Description of the operation for error messages
 * @param zoomOperation - The async Zoom operation to execute
 */
export function handleError(operation: string, error: unknown, errorContext: object = {}): void {
  if (isZoomExecutedFailure(error)) {
    const { type, reason, errorCode } = error;
    const errorMessage = `Zoom ${operation} failed: ${reason} (type: ${type}, code: ${errorCode})`;
    logger.error(errorMessage, { type, errorCode, reason });
  } else {
    // Handle non-Zoom exceptions
    logger.error(`${operation} failed`, errorContext, normalizeError(error));
  }
}
